var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"condition-button w-100",attrs:{"type":"button","data-applied":_vm.condition.applied},on:{"click":function($event){return _vm.onClick(_vm.condition)}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }